import { Camera } from "lucide-react";

// Elegant placeholder image slot. Renders <img> if `src` provided, else a labeled placeholder.
// `dark` tunes the placeholder for dark panels.
export const ImgSlot = ({ src, alt = "", label = "Photo coming soon", ratio = "4/3", className = "", dark = false }) => {
  if (src) {
    return (
      <div className={`overflow-hidden rounded-2xl bg-muted ring-1 ring-stone/5 ${className}`} style={{ aspectRatio: ratio }}>
        <img src={src} alt={alt} loading="lazy" className="h-full w-full object-cover" />
      </div>
    );
  }
  return (
    <div
      className={`img-slot rounded-2xl ${dark ? "img-slot-dark" : ""} ${className}`}
      style={{ aspectRatio: ratio }}
      aria-label={label}
      role="img"
    >
      <span className="img-slot-label">
        <Camera size={13} aria-hidden />
        {label}
      </span>
    </div>
  );
};

export default ImgSlot;
